import { useCallback } from 'react'
import Dotdotdot from 'react-dotdotdot'

import i18n from 'services/i18n'
import { Card } from 'lib/react-swipe-card'
import { getProfileImage } from 'services/redirectHelper'
import { MatchAvatar, SwipeCardActionButton } from 'components'
import c from './SwipeCard.module.scss'

const trimBio = (bio, maxLength = 250) => {
  if (!bio) return '';
  if (bio.length <= maxLength) return bio;
  return bio.substr(0, maxLength).trim() + '...';
};


const SwipeCard = (props) => {
  const {
    item,
    onSkipButton,
    onLikeButton,
    onRequestRommate,
    isBioEnabled,
    onClick, ...other
  } = props
  const { claimed, first_name, last_name, percent_match, membership_id } = item
  const avatar = getProfileImage(item)
  const fullName = `${first_name} ${last_name}`
  const isGreen = percent_match >= 50

  const handleKeyDown = useCallback((e) => {
    if (!props.active) return;

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        onSkipButton();
        break;
      case 'ArrowRight':
        e.preventDefault();
        onLikeButton();
        break;
      case 'Enter':
      case ' ':
        e.preventDefault();
        onClick(membership_id)();
        break;
      default:
        break;
    }
  }, [props.active, onSkipButton, onLikeButton, onClick, membership_id]);

  const bio = !!isBioEnabled === true ?
  <div className={c.bioContainer}>
    <Dotdotdot clamp={4} className={c.bio}>
      {trimBio(item.bio) || i18n.t('profile.noBio')}
    </Dotdotdot>
  </div> :
  <div className={c.bioContainer}>
    <Dotdotdot clamp={4} className={c.bio}>
    </Dotdotdot>
  </div>

  return (
    <article
      role="article"
      tabIndex={props.active ? 0 : -1}
      onKeyDown={handleKeyDown}
      aria-label={`${i18n.t('swipes.profileCard')}: ${fullName}, ${percent_match}% ${i18n.t('profile.compatible')}. ${i18n.t('swipes.keyboardInstructions')}`}
      aria-hidden={!props.active}
    >
      <Card className={c.container} item={item} {...other} onClick={onClick(membership_id)}>
        <h2 className={c.name} aria-hidden={String(!props.active)}>
          <Dotdotdot clamp={1}>{fullName}</Dotdotdot>
        </h2>
        <div className={c.avatarWrapper}>
          <MatchAvatar data={{ avatar, claimed, match: percent_match }} red={!isGreen} />
        </div>

        {bio}

        <section aria-label={i18n.t('swipes.actions')}>
          <div className={c.divider} />
          <div className={c.actions}>
            <SwipeCardActionButton type="skip" onClick={onSkipButton} />
            <SwipeCardActionButton type="view" onClick={onClick(membership_id)} />
            <SwipeCardActionButton type="request" onClick={onRequestRommate(item)} />
            <SwipeCardActionButton type="like" onClick={onLikeButton} />
          </div>
        </section>
      </Card>
    </article>
  );
}

export { SwipeCard }
